module.exports = __webpack_public_path__ + "img/guides001.2ec25653.jpg";